import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    add: {
        id: 'iaso.label.add',
        defaultMessage: 'Add',
    },
    delete: {
        id: 'iaso.label.delete',
        defaultMessage: 'Delete',
    },
    filters: {
        id: 'iaso.label.filters',
        defaultMessage: 'Filters',
    },
    settings: {
        id: 'iaso.label.settings',
        defaultMessage: 'Settings',
    },
    edit: {
        id: 'iaso.label.edit',
        defaultMessage: 'Edit',
    },
    comments: {
        id: 'iaso.label.comments',
        defaultMessage: 'Comments',
    },
    logout: {
        defaultMessage: 'Logout',
        id: 'iaso.logout',
    },
    homePage: {
        defaultMessage: 'Home page',
        id: 'iaso.users.label.homePage',
    },
    see: {
        defaultMessage: 'See',
        id: 'iaso.label.see',
    },
});

export default MESSAGES;
